










/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import OrganisationItem from "./OrganisationItem.vue";

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    components: {
        OrganisationItem
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class OrganisationList extends Vue {
    @Prop({ default: 'open' }) type!: string
};

